import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";

// Definir estilos para el botón
const StyledButton = styled.button`
	/* Agrega tus estilos personalizados aquí */
	background-color: #000;
	color: #fff;
	border: none;
	padding: 12px 20px 12px 12px;
	border-radius: 5px;
	cursor: pointer;
	font-size: 16px;
	width: 150px;

	&:hover {
		background-color: #212121;
		border: none;
	}
`;

const LoginButton = () => {
	const { loginWithRedirect } = useAuth0();

	return (
		<StyledButton
			onClick={() =>
				loginWithRedirect({
					authorizationParams: { prompt: "select_account" },
				})
			}
		>
			INICIAR SESIÓN
		</StyledButton>
	);
};

export default LoginButton;
